// biz 에러(710/711/712) 안내 모달 표시 진입점. 채널1(SSO 로그인 실패)·채널2(런타임 494 강제 로그아웃) 공통. (OMD-27)
//
// 실제 모달 렌더링(앱 공용 `errorBase` — 빨간 느낌표 삼각형 아이콘 포함)은 앱 계층에서 담당한다.
// packages/services 는 앱 UI(utils/ui, SVG 에셋)를 직접 import 하면 안 되므로(경계·번들·테스트),
// 앱이 `setBizErrorModalRenderer` 로 렌더러를 등록하고 본 모듈은 그 렌더러에 위임한다.
export type BizErrorModalRenderer = (code: number | string) => void

let renderer: BizErrorModalRenderer | null = null

export const setBizErrorModalRenderer = (fn: BizErrorModalRenderer): void => {
  renderer = fn
}

export const showBizErrorModal = (code: number | string): void => {
  renderer?.(code)
}
